import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import Favicon from 'icons/Favicon.icon';
import ChevronDownLargeIcon from 'icons/ChevronDownLarge.icon';
import { Button, Divider, styled, useMediaQuery, useTheme } from '@mui/material';
import BellIcon from 'icons/Bell.icon';
import FaviconRound from 'icons/FaviconRound.icon';
import PlusGreenIcon from 'icons/PlusGreen.icon';
import { useNavigate } from '@tanstack/react-router';
import authService from 'services/authService';
import { signOut } from 'utils/auth';
import MenuIcon from '@mui/icons-material/Menu';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
// import { useAuthStore } from 'store/authStore';
import Logout from '@components/Logout/Logout.components';

const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];

const StyledIconButton = styled(IconButton)(() => ({
  padding: '12px',
  borderRadius: '8px',
  border: '1px solid var(--Interviewer-Near-White)',
  color: '#000000',

  '& svg': {
    color: 'currentColor',
  },

  '&:hover': {
    background: 'inherit',
    border: '1px solid var(--Interviewer-Black)',
  },

  '&:active': {
    background: 'var(--Interviewer-Black)',
    color: '#ffffff',
  },
}));

const StyledButton = styled(Button)(() => ({
  padding: '8px 8px 8px 12px',
  borderRadius: '8px',
  background: '#fff',
  border: '1px solid var(--Light-Gray)',
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '24x',
  color: 'var(--Interviewer-Black)',
  boxShadow: 'none',

  '&:hover': {
    background: '#fff',
    boxShadow: 'none',
    cursor: 'default',
  },

  '.MuiButton-startIcon': {
    paddingRight: '8px',
    marginRight: '8px',
    borderRight: '1px solid var(--Light-Gray)',
  },

  '.MuiButton-endIcon': {
    marginLeft: '48px',
  },
}));

const StyledLogoutText = styled(Typography)(() => ({
  fontWeight: 500,
  fontSize: '16px',
  color: 'var(--Interviewer-Green)',
  cursor: 'pointer',
}));

interface NavBarProps {
  burgerMenuClick?: () => void;
}

const NavBar: React.FC<NavBarProps> = ({ burgerMenuClick }) => {
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();

  // const userSettings = useAuthStore();
  const currentRole = (role: string) => {
    switch (role) {
      case 'BasicUser':
        return 'Candidate';
      case 'Admin':
        return 'Admin';
      case 'SuperAdmin':
        return 'SuperAdmin';
      default:
        return '';
    }
  };
  
  const { data } = useQuery({
    queryKey: ['personalSettings'],
    queryFn: async () => {
      const token = localStorage.getItem('token');
      const response = await axios.get('https://interviewer.runasp.net/api/users/personal-settings', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log(response.data);
      
      return response.data;
    }
  });

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };


  return (
    <AppBar position="sticky">
      <Toolbar disableGutters sx={{ padding: '20px 24px', gap: '24px' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            flex: 1,
          }}
        >
          <Favicon />
          <Typography variant="h3">Interviwer</Typography>
        </Box>

        {!isMobile && (
          <>
          {/* {userSettings?.roles[0] === 'BasicUser' && ( */}
            <Box>
              <StyledButton
                variant="contained"
                startIcon={<FaviconRound />}
                onClick={() => navigate({ to: '/credits' })}
              >
                {data?.tokensCount} Credits
                <Box
                  component="span"
                  sx={{ ml: 2, display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                  onClick={() => navigate({
                    to: '/credits'
                  })}
                >
                  <PlusGreenIcon />
                </Box>
              </StyledButton>

              <Divider
                orientation="vertical"
                sx={{
                  borderColor: 'var(--Interviewer-Near-White)',
                }}
              />
            </Box>
          {/* )} */}
                
            {/* <StyledIconButton>  
              <BellIcon />  
            </StyledIconButton> */}

            <Box>
              <Box sx={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                <Avatar 
                  onClick={() => navigate({
                    to: '/profile/info'
                  })}
                  alt="Danilo Mladenovic" 
                  sx={{cursor: 'pointer'}}
                  />
                <Box>
                  <Typography variant="h4">{data?.firstName}</Typography>
                  {/* <Typography variant="body2">{currentRole(userSettings.roles[0])}</Typography> */}
                </Box>

                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{
                    borderColor: 'var(--Interviewer-Near-White)',
                  }}
                />
                <Logout />

                {/* <Tooltip title="Open settings">
                  <IconButton
                    onClick={handleOpenUserMenu}
                    sx={{ p: 0, backgroundColor: 'transparent' }}
                  >
                    <ChevronDownLargeIcon />
                  </IconButton>
                </Tooltip> */}
              </Box>

              {/* <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {settings.map((setting) => (
                  <MenuItem 
                    key={setting} 
                    onClick={setting === 'Logout' ? handleLogout : handleCloseUserMenu}
                  >
                    <Typography sx={{ textAlign: 'center' }}>{setting}</Typography>
                  </MenuItem>
                ))}
              </Menu> */}
            </Box>
          </>
        )}

        {isMobile && (
          <IconButton
            onClick={burgerMenuClick}
            sx={{ ml: 'auto' }}
          >
            <MenuIcon />
          </IconButton>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default NavBar;
